/*
 * fixed 模块
 */
const produceMap = (options) => {
  const res = {};
  (options || []).forEach(opt => {
    res[opt.id] = opt;
  })
  return res;
}
// 外观状态
export const FASHION_STATE_OPTIONS = [
  { id: 1, label: '在售' },
  { id: 2, label: '下架' },
];
export const FASHION_STATE_MAP = produceMap(FASHION_STATE_OPTIONS);
// L36纹玉类型
export const WY_TYPE_OPTIONS = [
  { id: 1005, label: '绑定' },
  { id: 1006, label: '非绑定' },
];
export const WY_TYPE_MAP = produceMap(WY_TYPE_OPTIONS);

// 外观分类
export const FASHION_TYPE_OPTIONS = [
  { id: 1, label: '时装' }
];
export const FASHION_TYPE_MAP = produceMap(FASHION_TYPE_OPTIONS);

// 时装截图地址
export const FASHION_IMG_URL = `https://store.uxlab.leihuo.netease.com/file/public/dcfashion/`;

/*
 * uxExperience 模块
 */
export const MODE_ID_MAP = {
  ALL: -1,
  TOUR: 3,
  SOLO: 0,
  SMASH: 2,
  TROIS: 1,
  BUDDY_CUP: 4
}

export const CATEGORY_TYPE_MAP = {
  BASE: 0,
  TROIS: 1,
  BUDDY_CUP: 2
}